<template>
  <v-app>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="data"
      :single-select="singleSelect"
      item-key="id"
      show-select
      style="padding:25px"
    >
      <template v-slot:top>
        <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title
                ><b>{{ title }}</b></v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-spacer></v-spacer>
              <v-breadcrumbs>Master Data / Special Proc</v-breadcrumbs>
              <v-btn icon v-on:click="getData()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
              <v-layout row>
                <v-flex md8>
                  <v-btn
                    rounded
                    style="margin-top:15px"
                    color="primary"
                    large
                    v-on:click="modalForm()"
                  >
                    <v-icon dark style="margin-right:10px">mdi-plus</v-icon>
                    Add Data
                  </v-btn>
                </v-flex>
                <v-flex md4>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      label=""
                      v-model="val"
                      v-on:keyup.enter="getData()"
                      placeholder="Enter Your Keywords"
                      solo
                      append-icon="search"
                    ></v-text-field>
                  </v-col>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>

        <v-dialog v-model="modal_form" max-width="500px">
          <v-card>
            <v-card-title>
              Special Proc
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <div style="padding:10px">
                  <label>
                    Special Proc Code
                  </label>
                  <v-text-field
                    v-model="special_proc_code"
                    :rules="rules"
                    :disabled="disabled"
                    placeholder="Enter Special Proc Code"
                    required
                    solo
                  ></v-text-field>

                  <label>
                    Special Proc Name
                  </label>
                  <v-text-field
                    v-model="special_proc_name"
                    :rules="rules"
                    placeholder="Enter Special Proc Name"
                    required
                    solo
                  ></v-text-field>
                </div>

                <div align="right">
                  <v-btn color="primary" text @click="modal_form = false">
                    Close
                  </v-btn>

                  <v-btn
                    color="primary"
                    text
                    :loading="loading"
                    v-on:click="processForm"
                  >
                    Process
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip color="success" v-if="item.status == 'Y'">Active</v-chip>
        <v-chip color="error" v-if="item.status == 'N'">Inactive</v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon medium class="mr-2" @click="edit(item)">
          mdi-file-edit
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="error"
          @click="changeStatus(item, 'N')"
          v-if="item.status == 'Y'"
        >
          mdi-close-circle
        </v-icon>

        <v-icon
          medium
          class="mr-2"
          color="success"
          @click="changeStatus(item, 'Y')"
          v-if="item.status == 'N'"
        >
          mdi-check-circle
        </v-icon>
      </template>
    </v-data-table>
  </v-app>
</template>

<script>
export default {
  methods: {
    getData() {
      var self = this
      var val = self.val

      var url = self.base_url + "master/getdata/special_proc"
      self.axios
        .post(url, {
          param: val,
        })
        .then(function(response) {
          self.data = response.data
        })
    },
    modalForm() {
      var self = this
      self.modal_form = true
      self.reset()
      self.disabled = false
    },
    edit(item) {
      var self = this
      self.modal_form = true

      self.id = item.id
      self.special_proc_code = item.special_proc_code
      self.special_proc_name = item.special_proc_name
      self.disabled = true
    },
    reset() {
      this.id = ""
      this.$refs.form.reset()
      this.type = "INSERT"
    },
    processForm() {
      var self = this
      if (self.$refs.form.validate()) {
        var url = (url = self.base_url + "master/process/add_special_proc")
        self.loading = true

        self.axios
          .post(url, {
            special_proc_code: self.special_proc_code,
            special_proc_name: self.special_proc_name,
            id: self.id,
          })
          .then(function(response) {
            if (response.data) {
              self.modal_form = false
              alert("Data succesfully saved")
            } else {
              alert(response.data.messages)
            }
            self.getData()
            self.loading = false
          })
      }
    },
    changeStatus(item, status) {
      var self = this
      var url = self.base_url + "master/process/change_status"

      var text_confirm = "Are you sure you want to Deactivated this data ?"

      if (status == "Y") {
        text_confirm = "Are you sure you want to Activated this data ?"
      }

      this.$dialog.confirm({
        text: text_confirm,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              self.axios
                .post(url, {
                  id: item.id,
                  status: status,
                  table: "mst_special_proc",
                  field: "id",
                })
                .then(function(response) {
                  alert(response.data.message)
                  self.getData()
                })
            },
          },
        },
      })
    },
    getPurchasingGroup() {
      var self = this
      var url =
        self.base_url +
        "master/dropdown/attribute/special_proc/special_proc_code"
      self.axios.get(url).then(function(response) {
        self.list_special_proc = response.data
      })
    },
  },
  mounted() {
    this.getData()
    this.getPurchasingGroup()
  },
  data() {
    return {
      name: "ExternalGroup",
      title: "Data Special Proc",
      dialog: false,
      widgets: false,
      singleSelect: false,
      selected: [],
      showSelect: false,
      val: "",
      headers: [
        {
          text: "Special Proc Code",
          value: "special_proc_code",
          width: 120,
        },
        {
          text: "Special Proc Name",
          value: "special_proc_name",
          width: 250,
        },
        { text: "Status", value: "status", sortable: true, width: 120 },
        { text: "Action", value: "action", sortable: false, width: 120 },
      ],
      data: [],
      modal_detail: false,
      detail: [],
      modal_form: false,
      rules: [
        (v) => !!v || "Form is required",
        //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
      ],
      list_special_proc: [],

      //form..............................
      special_proc_code: "",
      special_proc_name: "",
      id: "",
      type: "",
      disabled: false,
    }
  },
}
</script>
